"use client"

import React from 'react';
import styles from "./Cover.module.css"
import {Link} from "@/i18n/routing";
import Image from "next/image";
import {IoChevronBack} from "react-icons/io5";

type Props = {
  children: React.ReactNode,
  backElements?: React.ReactNode,
  image: string,
  link: string
  title: string
}

export default function Cover(props: Props) {
  const {children, image, link, title, backElements} = props
  return <div className={styles.cover}>
    <Link className={styles.back} href={link}><IoChevronBack size={30}/>{backElements}</Link>
    <Image fill className={styles.image} unoptimized src={image} alt={'thumb'}/>
    <div className={styles.backDrop}/>
    <div className={styles.titleWrapper}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.bottomTab}>
        {children}
      </div>
    </div>
  </div>
}
